import { Entity } from '@app/constants/enums/entites';
import { IClient } from '@app/interfaces/client';
import { createAction, createSlice, PrepareAction } from '@reduxjs/toolkit';

export interface ClientState {
  client: IClient | null;
}

const initialState: ClientState = { client: null };

export const setClient = createAction<PrepareAction<IClient>>('client/setClient', (client) => {
  return {
    payload: client,
  };
});

export const clientSlice = createSlice({
  name: Entity.CLIENT,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setClient, (state, action) => {
      state.client = action.payload;
    });
  },
});

export default clientSlice.reducer;
